import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "Qu'est-ce qu'un cookie ?",
    body: [
      "Un cookie est un petit fichier texte déposé sur votre appareil (ordinateur, smartphone, tablette) lors de la consultation d'un site internet. Il permet notamment le fonctionnement technique du site ou la mesure d'audience.",
    ],
  },
  {
    title: "Cookies utilisés sur ce site",
    body: [
      "Le site AVELIS n'utilise actuellement aucun cookie publicitaire, aucun cookie de mesure d'audience tiers et aucun traceur marketing.",
      "Seuls des éléments techniques strictement nécessaires au fonctionnement et à la sécurité du site peuvent être utilisés (par exemple la mémorisation de préférences d'affichage). Ces éléments ne nécessitent pas votre consentement.",
    ],
  },
  {
    title: "Outils d'analyse",
    body: [
      "Aucun outil d'analyse d'audience (type Google Analytics) n'est actif sur ce site à ce jour.",
      "Si de tels outils sont activés à l'avenir, ils ne seront déclenchés qu'après recueil de votre consentement via un bandeau dédié, et la présente page sera mise à jour en conséquence.",
    ],
  },
  {
    title: "Gérer vos préférences",
    body: [
      "Vous pouvez à tout moment configurer votre navigateur pour être informé du dépôt de cookies, les refuser ou les supprimer. La marche à suivre se trouve dans le menu d'aide de votre navigateur (Chrome, Firefox, Safari, Edge).",
      "Le refus des éléments techniques peut toutefois altérer le fonctionnement de certaines parties du site.",
    ],
  },
  {
    title: "Contact",
    body: [
      "Pour toute question relative à cette politique : contact@avelis.be — +32 489 56 78 88.",
      "Responsable : DK Soins SRL (marque AVELIS), Route de Gosselies 27/8, 6220 Fleurus, Belgique.",
    ],
  },
];

const Cookies = () => (
  <>
    <Seo
      title="Gestion des cookies | AVELIS"
      description="Politique de gestion des cookies du site AVELIS : aucun traceur publicitaire, uniquement le strict nécessaire technique."
    />
    <section data-testid="cookies-page" className="pt-[130px] sm:pt-[160px] pb-16 sm:pb-24 bg-[#f6f3ec]">
      <div className="container-avelis max-w-3xl">
        <Reveal>
          <p className="eyebrow"><span className="dot-sage" />Légal</p>
          <h1 className="mt-5 text-4xl sm:text-5xl font-extrabold tracking-tight text-[#0d2731]">Gestion des cookies</h1>
          <p className="mt-5 text-sm text-[#4b585e]">Dernière mise à jour : octobre 2026</p>
          <div className="mt-10 space-y-10">
            {SECTIONS.map((s) => (
              <section key={s.title}>
                <h2 className="text-xl font-extrabold tracking-tight text-[#0d2731]">{s.title}</h2>
                <div className="mt-3 space-y-2">
                  {s.body.map((p, i) => (
                    <p key={i} className="text-sm sm:text-base text-[#4b585e] leading-relaxed">{p}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  </>
);

export default Cookies;
